import { getBase } from './base'
import { colours } from './colours'
import { textStyles } from './text-styles'

export const styles = `
  ${getBase({ colours, textStyles })}
`
